import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid'; // Pour générer un UUID
import { compressImageFile, isHeicFile, IMAGE_ACCEPT } from '../../utils/imageCompression';
import '../../styles/Audit.css';

function AuditPageCreationClient() {
  const navigate = useNavigate();

  // États pour stocker les valeurs du formulaire
  const [clientName, setClientName] = useState('');
  const [numEmployees, setNumEmployees] = useState('');
  const [revenue, setRevenue] = useState('');
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogoChange = async (event) => {
    let file = event.target.files[0];
    event.target.value = '';
    if (!file) return;
    // Seul un HEIC est converti en JPEG (illisible hors Safari, et une URL
    // Cloudinary en .heic ne se supprime pas) : recompresser un logo PNG lui
    // ferait perdre sa transparence.
    if (isHeicFile(file)) {
      try {
        file = await compressImageFile(file);
      } catch (err) {
        console.error('Lecture du logo impossible :', err);
        alert("Ce format d'image n'a pas pu être lu. Essayez avec un fichier JPEG ou PNG.");
        return;
      }
    }
    setLogoFile(file);
    setLogoPreview(URL.createObjectURL(file));
  };

  const handleDeleteLogo = () => {
    setLogoFile(null);
    setLogoPreview(null);
  };

  // Gestion de la soumission du formulaire
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      let logoUrl = '';
      if (logoFile) {
        const formData = new FormData();
        formData.append('image', logoFile, logoFile.name || 'logo.jpg');
        const uploadResponse = await fetch(`${process.env.REACT_APP_API_URL}/upload_image`, {
          method: 'POST',
          body: formData,
        });
        const uploadData = await uploadResponse.json();
        logoUrl = uploadData.image_url || '';
      }

      // Générer un UUID pour le client
      const clientData = {
        _id: uuidv4(),
        name_client : clientName,
        employee_count : numEmployees ? parseFloat(numEmployees) : null,
        revenue: revenue ? parseFloat(revenue) : null,
        logo_url: logoUrl,
      };

      const response = await fetch(`${process.env.REACT_APP_API_URL}/load_new_client`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(clientData),
      });

      if (response.ok) {
        alert('Client enregistré avec succès !');
        navigate(`/audit/${clientData._id}`);
      } else {
        alert("Erreur lors de l'enregistrement.");
      }
    } catch (error) {
      console.error('Erreur API:', error);
      alert("Erreur de connexion à l'API.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-container-client">
      <h2>Création d'un nouveau client</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nom du client</label>
          <input
            type="text"
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Nombre d'employés</label>
          <input
            type="number"
            value={numEmployees}
            onChange={(e) => setNumEmployees(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Chiffre d'affaires</label>
          <input
            type="number"
            value={revenue}
            onChange={(e) => setRevenue(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Logo du client</label>
          <div className="equip-photo-wrap">
            <input
              type="file"
              id="client-logo"
              accept={IMAGE_ACCEPT}
              onChange={handleLogoChange}
              style={{ display: 'none' }}
            />
            {!logoPreview ? (
              <label htmlFor="client-logo" className="equip-photo-dropzone">
                <span className="equip-photo-dropzone-icon">🖼️</span>
                <span className="equip-photo-dropzone-text">Ajouter un logo</span>
              </label>
            ) : (
              <div className="equip-photo-preview">
                <img src={logoPreview} alt="Aperçu du logo" />
                <div className="equip-photo-actions">
                  <label htmlFor="client-logo" className="equip-photo-change">Changer</label>
                  <button type="button" className="equip-photo-delete" onClick={handleDeleteLogo}>Supprimer</button>
                </div>
              </div>
            )}
          </div>
        </div>
        <button className="save-button" type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Enregistrement...' : "Commencer l'audit du client"}
        </button>
      </form>
    </div>
  );
}

export default AuditPageCreationClient;
